// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

if (document.querySelector('.podcastCarousel')) {
  const swiperEl = document.querySelector('.podcastCarousel__swiper')
  const prevBtn = document.querySelector('.podcastCarousel__prevBtn')
  const nextBtn = document.querySelector('.podcastCarousel__nextBtn')

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1.5,
    spaceBetween: 40,
    breakpoints: {
      560: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  });

  prevBtn.addEventListener('click', () => {
    swiper.slidePrev();
  })

  nextBtn.addEventListener('click', () => {
    swiper.slideNext();
  })
}